var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const Scatter = (_a) => {
    var { transform, data, domain, pointStyle, onPointMouseOver, onPointMouseOut, onPointClick } = _a, props = __rest(_a, ["transform", "data", "domain", "pointStyle", "onPointMouseOver", "onPointMouseOut", "onPointClick"]);
    if (transform === undefined)
        throw new Error("Scatter component must receive a transform prop. Did you render one outside a <PlotArea>?");
    return data.length >= 1 ? (React.createElement(React.Fragment, null, data.map((point, i) => {
        const t = transform(point);
        const pointProps = point.svgProps || {};
        return (React.createElement("circle", Object.assign({ r: 2, key: i, cx: t.x, cy: t.y, onMouseOver: e => onPointMouseOver && onPointMouseOver(i, e), onMouseOut: e => onPointMouseOut && onPointMouseOut(i, e), onClick: e => onPointClick && onPointClick(i, e) }, pointStyle, pointProps)));
    }))) : null;
};
export default Scatter;
